<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách công việc của Sale</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          data-toggle="tooltip"
          data-placement="top"
          data-original-title="Xuất Excel"
          @click="exportExcel"
        >
          <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.merchantName"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên merchant"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  TG hoàn thành
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2MultipleControl
              :settings="{ placeholder: 'Tên Sale', multiple: false }"
              v-model="search.saleIds"
              :options="dataManager"
            >
            </Select2MultipleControl>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mcRegionId"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.provinceIds"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="[
                {
                  id: 'NO_APPROVE',
                  text: 'Chưa duyệt',
                },
                {
                  id: 'APPROVE',
                  text: 'Đã duyệt',
                },
                {
                  id: 'REJECT',
                  text: 'Từ chối',
                },
              ]"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(operationType)="data">
                <span
                  class="badge"
                  :class="[data.item.operationType ? data.item.operationType : 'WAITING']"
                >
                  {{ data.item.operationType | transformData(Config.statusJob) }}
                </span>
                <div v-if="data.item.operationType && data.item.operationType === 'REJECT'">
                  <p v-if="data.item.rejectNote" class="form-control-plaintext f12">
                    Lý do: &nbsp; {{ data.item.rejectNote }}
                  </p>
                </div>
              </template>
              <template #cell(merchantName)="data">
                <p>{{ data.item.merchantName }}</p>
                <p>{{ data.item.merchantEmail }}</p>
              </template>
              <template #cell(saleName)="data">
                <p>{{ data.item.saleName }}</p>
              </template>
              <template #cell(approveInfo)="data">
                <p>{{ data.item.approveByName }}</p>
              </template>
              <template #cell(createdDate)="data">
                <p><b>Tạo:</b> {{ data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                <p>
                  <b>Hoàn thành:</b>
                  {{ data.item.timeFinish | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p><b>Duyệt:</b> {{ data.item.approveAt | formatDate('HH:mm, DD/MM/YYYY') }}</p>
              </template>
              <!-- <template #cell(region)="data">
                {{
                  data.item.regionName.length > 0 ? data.item.regionName[0] : ""
                }}
              </template> -->
              <template #cell(province)="data">
                {{ data.item.city }}
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(data.item.id)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { GPDKKDService } from '@/services/gpdkkd.service'
  import cloneDeep from 'lodash/cloneDeep'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchantName', label: 'MC' },
    { key: 'saleName', label: 'Sale' },
    { key: 'approveInfo', label: 'Người duyệt' },
    { key: 'createdDate', label: 'TG' },
    // { key: 'region', label: 'Vùng', thStyle: 'width: 180px' },
    { key: 'province', label: 'Tỉnh/ thành phố', thStyle: 'width: 180px' },
    { key: 'operationType', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'gpdkkd-sale',
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataManager: [],
        search: {
          limit: 20,
          page: 1,
        },
        dataConfigRegion: [],
        dataProvince: [],
        pagination: {
          total: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    created() {
      this.getRegions()
      this.fetchSuperiors()
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          } else this.dataProvince = []
        } catch (error) {}
      },
      async fetchSuperiors() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: JSON.parse(localStorage.getItem('userData')).userId,
          })
          const dat = data.data.map(e => {
            return { id: e.userId, text: e.name }
          })
          this.dataManager = [{ id: '0', text: 'Tất cả' }, ...dat]
        } catch (e) {
          console.error(e)
        }
      },
      transformDate() {
        this.search.completeFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.completeTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.selected = []
        this.dataProvince = []
        await this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          if (this.search.saleIds === '0') delete this.search.saleIds
          if (this.search.mcRegionId === '0') delete this.search.mcRegionId
          if (this.search.provinceIds === '0') delete this.search.provinceIds
          const params = cloneDeep(this.search)
          if (params.saleIds) params.saleIds = [params.saleIds]
          if (params.provinceIds) params.provinceIds = [params.provinceIds]
          params.pageIndex = params.page
          params.pageSize = params.limit
          const response = await GPDKKDService.fetchSale(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.meta.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      detail(id) {
        const routeData = this.$router.resolve({
          path: `/gpdkkd/sale/${id}`,
        })
        window.open(routeData.href, '_blank')
      },
      async exportExcel() {
        try {
          if (this.search.saleIds === '0') delete this.search.saleIds
          if (this.search.mcRegionId === '0') delete this.search.mcRegionId
          if (this.search.provinceIds === '0') delete this.search.provinceIds
          const params = cloneDeep(this.search)
          if (params.saleIds) params.saleIds = [params.saleIds]
          if (params.provinceIds) params.provinceIds = [params.provinceIds]
          params.pageIndex = 1
          params.pageSize = 100000
          this.loading = true
          await GPDKKDService.exportExcelSale(params)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>
